import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, db } from '../../../firebase';
import { checkActionCode, applyActionCode } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import '../login_page/login_page.css';

const EmailUpdateHandler = () => {
  const [oobCode, setOobCode] = useState(null);
  const [newEmail, setNewEmail] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Extract the oobCode from the URL query params (?oobCode=...)
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('oobCode');

    if (code) {
      setOobCode(code);
      
      // 2. Verify the action code with Firebase Auth
      checkActionCode(auth, code)
        .then((info) => {
          // info.data.email contains the target new email address Firebase is staging
          if (info.data && info.data.email) {
            setNewEmail(info.data.email);
          }
          setIsValid(true);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Firebase action code verification failed:", error);
          alert("The verification link is invalid, broken, or has already been used.");
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [location]);

  const handleConfirmEmailUpdate = async (e) => {
    e.preventDefault();
    setProcessing(true);

    try {
      // 3. Apply the email change to Firebase Authentication
      await applyActionCode(auth, oobCode);

      // 4. Update the email field in your Firestore registrations collection
      // If a user is not logged in on this specific browser, we fetch the current action target user state
      const user = auth.currentUser;
      if (user && newEmail) {
        const userRef = doc(db, "registrations", user.uid);
        await updateDoc(userRef, { 
          email: newEmail.toLowerCase().trim() 
        });
        console.log("Firestore account mirror document updated successfully.");
      }

      alert("Your email address has been successfully verified and updated!");
      navigate('/login-parm');

    } catch (error) {
      console.error("Failed to apply email action mutation code:", error);
      alert("Verification failed: " + error.message);
    } finally {
      setProcessing(false);
    }
  };

  if (loading) return <div className="loader">Verifying your request string...</div>;
  if (!isValid) return <div className="error-view">Invalid or expired email change tracking token link. Please request a new link from your profile dashboard page settings.</div>;

  return (
    <div className="login-container">
      <form className="forgot-form" onSubmit={handleConfirmEmailUpdate}>
        <h2>Confirm Email Update</h2>
        <p>You are changing your official PArM account login identifier email address profile parameter.</p>
        
        <div className="input-group-login">
          <label>Target New Email Address</label>
          <input 
            type="email" 
            value={newEmail || "Your new email address"} 
            disabled 
            className="locked" 
            style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#7f8c8d' }}
          />
        </div>

        <button type="submit" className="login-btn" disabled={processing}>
          {processing ? "Updating..." : "Confirm & Apply Change"}
        </button>
      </form>
    </div>
  );
};

export default EmailUpdateHandler;